export const boxType = {
  TOTAL: 'total',
  CONNECTIONS: 'connections',
  RATING: 'rating',
  COMPLETED: 'completed',
  CANCELED: 'canceled',
  NO_SHOW: 'noShow',
};
